// page list config
import Home from '@/pages/Home'
import LiveList from '@/pages/LiveList'

 import CourseList from '@/pages/CourseList'
 import ClassList from '@/pages/ClassList'
import CourseDetail from '@/pages/CourseDetail'
 import ClassDetail from '@/pages/ClassDetail'
 import About from '@/pages/About'
 import ClassDetailForS from '@/pages/ClassDetailForS'
import MyCourse from '@/pages/MyCourse'
import MyCollection from '@/pages/MyCollection'
import MyQuestions from '@/pages/MyQuestions'
import MyAccountSetting from '@/pages/MyAccountSetting'
import MyLive from '@/pages/MyLive'
import MyTraining from '@/pages/MyTraining'
import MyAchievements from '@/pages/MyAchievements'
const pageList = {
    home: {
        title: '首页',
        name: 'home',
        component: Home
    },
    LiveList: {
        title: '直播列表',
        name: 'LiveList',
        component: LiveList
    },
    CourseList: {
        title: '课程中心',
        name: 'LiveList',
        component: CourseList
    },
    ClassList: {
        title: '班级中心',
        name: 'ClassList',
        component: ClassList
    },
    CourseDetail:{
        title: '课程详情',
        name: 'CourseDetail',
        component: CourseDetail
    },
    ClassDetail: {
        title: '班级详情',
        name: 'ClassDetail',
        component: ClassDetail
    },
    About: {
        title: '关于我们',
        name: 'About',
        component: About
    },
    ClassDetailForS:{
        title:"班级详情",
        name: 'ClassDetailForS',
        component: ClassDetailForS
    },
    MyCourse:{
        title:"我的课程",
        name:"MyCourse",
        component: MyCourse
    },
    MyCollection:{
        title:"我的收藏",
        name:"MyCollection",
        component: MyCollection
    },
    MyQuestions: {
        title:"我的问答",
        name: "MyQuestions",
        component: MyQuestions
    },
    MyAccountSetting: {
        title:"资料设置",
        name:"MyAccountSetting",
        component: MyAccountSetting
    },
    MyLive: {
        title:"我的直播",
        name: "MyLive",
        component: MyLive
    },
    MyTraining: {
        title: "我的培训",
        name: "MyTraining",
        component: MyTraining
    },
    MyAchievements:{
        title: "我的成果",
        name: "MyAchievements",
        component: MyAchievements
    }
};

export default pageList;